import React, { useEffect } from 'react';
import uploadIcon from '../../../shared/assets/svg/upload.svg';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

export const ImportSummaryForm = () => {
  const userId = Cookies.get('userId');

  // Track form view
  useEffect(() => {
    mixpanel.track('Super Admin Import Summary Form Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      mixpanel.track('Super Admin Import Summary File Selected', {
        user_id: userId,
        file_name: file.name,
        file_size: file.size,
        file_type: file.type,
        file_size_mb: (file.size / (1024 * 1024)).toFixed(2),
        timestamp: new Date().toISOString()
      });

      // Validate file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        mixpanel.track('Super Admin Import Summary File Rejected', {
          user_id: userId,
          file_name: file.name,
          file_size: file.size,
          rejection_reason: 'file_too_large',
          timestamp: new Date().toISOString()
        });
        alert('File size exceeds 10MB limit');
        e.target.value = '';
        return;
      }

      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        mixpanel.track('Super Admin Import Summary File Rejected', {
          user_id: userId,
          file_name: file.name,
          file_type: file.type,
          rejection_reason: 'invalid_file_type',
          timestamp: new Date().toISOString()
        });
        alert('Please select a JPG, PNG, or PDF file');
        e.target.value = '';
        return;
      }

      mixpanel.track('Super Admin Import Summary File Accepted', {
        user_id: userId,
        file_name: file.name,
        file_size: file.size,
        file_type: file.type,
        timestamp: new Date().toISOString()
      });
    }
  };

  const handleLabelClick = () => {
    mixpanel.track('Super Admin Import Summary Choose File Clicked', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  };

  return (
    <div className="flex w-full gap-4 justify-center flex-col items-center text-center mt-16 p-5 font-helvetica border-dashed border-2 border-[#e9f5f6] ">
      <div>
        <img src={uploadIcon} alt="" />
      </div>
      <h4 className="font-helvetica font-medium">Select a file or drag and drop here</h4>
      <p className="text-importColor font-normal">JPG, PNG or PDF, file size no more than 10MB</p>
      <div className="cursor-pointer">
        <input
          type="file"
          className="file-input"
          name="file"
          id="file"
          onChange={handleFileChange}
          accept=".jpg,.jpeg,.png,.pdf"
        />
        <label
          className="border p-2 rounded-md border-[#346C75] text-[#346C75]"
          htmlFor="file"
          onClick={handleLabelClick}>
          Choose File
        </label>
      </div>
    </div>
  );
};
